import config from '../../lib/config';
import React from 'react';
import ReactDOM from 'react-dom';

function getFeaturedImage(post) {
  let featuredImg;

  if ( typeof post._embedded[ 'wp:featuredmedia' ] !== 'undefined' ) {

    // Add the thumbnail size if it exists.
    if ( typeof post._embedded[ 'wp:featuredmedia' ][ 0 ].media_details.sizes.grid_images !== 'undefined' ) {
        featuredImg = post._embedded[ 'wp:featuredmedia' ][ 0 ].media_details.sizes.grid_images.source_url;
    } else {
        featuredImg = post._embedded[ 'wp:featuredmedia' ][ 0 ].source_url;
    }
  }
  return featuredImg;
}

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

function Post(props) {
  let featuredImg = getFeaturedImage(props.post),
      altText = typeof props.post._embedded[ 'wp:featuredmedia' ] !== 'undefined' ? props.post._embedded[ 'wp:featuredmedia' ][ 0 ].alt_text : '',
      title = decodeHtml(props.post.title.rendered),
      catLabel = props.post._embedded['wp:term'][0][0].name;

  return(
    <article className="post">
      <a href={props.post.link} className="post-link">
        <figure className="entry-image-wrap">
          <img className="entry-image" src={featuredImg} alt={altText} />
        </figure>
        <header className="entry-header">
          { props.catDisplay == true ? <p className="entry-meta"><span className="entry-category">{catLabel}</span></p> : '' }
          <h2 className="entry-title">{title}<span className="blog-dash icon-minus-solid"></span></h2>
        </header>
        <div className="posts-overlay" aria-hidden="true"></div>
      </a>
    </article>
  );
}

/** 
 * So React won't allow you to run the map method on an object, which props.posts is initially.
 * We use a for loop to create an array of posts then.
 * Went round and round on this. Could be a better way, but for now, it works. 
 */
function Posts(props) {
  let postsObj = props.posts,
      posts = [],
      post;
  for ( post of postsObj) {
    posts.push(post);
  }
  return (
    <div className="more-posts posts-wrap">
      {posts.map(function(post) {
        return <Post post={post} key={post.id} catDisplay={props.catDisplay}/>;
      })}
    </div>
  );
}

/**
 * This is the parent component where the magic happens
 */
class PostsContainer extends React.Component {
  constructor(props) {
    // super is a default React thing. Ya just need it.
    super(props);
    // If you don't bind the onClick method to the parent container, it tries to assign it to the button itself. Very confusing.
    this.onClick = this.onClick.bind(this);
    // Setting the initial states of the components. Posts are empty, the button is visible.
    this.state = {
      posts: '',
      btnDisplay: true,
      postsDisplay: false,
      catDisplay: true
    };
  }

  // Once everything is loaded, we fetch the posts.
  componentDidMount() {
     this.getPosts();
  }

  // Using Node WPAPI (instantiated in Config) to fetch up to 100 posts (can't exceed that) with an offset of 10.
  // Then we use the result to set the posts state.
  getPosts() {
    let catID = config.catID,
        author = typeof Author === 'undefined' ? '' : Author,
        offset,
        catDisplay;
console.log(author.isArchive);
    if ( catID < 1 && author.isArchive != true ) {
      offset = '13';
      catDisplay = true;
    } else if ( catID < 1 && author.isArchive == true ) {
      offset = '12';
      catDisplay = true;
    } else {
      offset = '12';
      catDisplay = false;
    }

    return config.wp.posts()
      .category(catID)
      .perPage(100)
      .offset(offset)
      .embed().then( 
        result => {
          this.setState( {posts: result} );
          this.setState( {catDisplay: catDisplay } );
      }).catch( err => {
          console.log('Problem! Status Code: ' +
            err);
      });
  }

  onClick() {
    this.setState({btnDisplay:false});
    this.setState({postsDisplay:true});
  }

  render() {
    return (
      <div className="posts-container">

        {this.state.btnDisplay ? <div className="pagination"><button className="button w-button" onClick={this.onClick}>Load More</button></div> : <div className="pagination"><span className="blog-dash icon-minus-solid"></span></div>}

        {this.state.postsDisplay ? <Posts posts={this.state.posts} catDisplay={this.state.catDisplay} /> : null}

      </div>
    );
  }

}

export default class RenderPosts {

  static render() {
    ReactDOM.render(<PostsContainer />, document.getElementById("posts-root"));
  }
}
